import CategoriesItemElectronics from "./CategoriesItemElectronics";
import Footer from "../Footer";
import Newsletter from "../Newsletter";

function Electronics() {
  return (
    <>
      <CategoriesItemElectronics />
      <Newsletter />
    </>
  );
}

export default Electronics;
